export interface StaticLink {
  display: string;
  href: string;
  isExternal?: boolean;
  newWindow?: boolean;
  splitTreatment?: string;
  showNewNotification?: boolean;
  eventTracking?: Record<string, string | number | boolean>;
}

export const homeLinks: Array<StaticLink> = [
  {
    display: 'Home',
    href: '/',
    isExternal: false,
    newWindow: false,
  },
];

export const learnLinks: Array<StaticLink> = [
  {
    display: 'Support Center',
    href: 'https://support.surfline.com/hc/en-us',
    isExternal: true,
    newWindow: true,
  },
  {
    display: 'Travel Guides',
    href: '/travel',
    isExternal: false,
    newWindow: false,
  },
  {
    display: 'Surf Spot Mechanics',
    href: '/series/mechanics',
    isExternal: false,
    newWindow: false,
  },
  {
    display: 'Surf Etiquette',
    href: 'https://www.surfline.com/lp/surf-etiquette',
    isExternal: true,
    newWindow: true,
  },
  {
    display: 'Surf Safety Basics',
    href: '/surf-news/surf-safety-basics/222989',
    isExternal: false,
    newWindow: false,
  },
  {
    display: 'Coastal Resilience',
    href: '/series/environment',
    isExternal: false,
    newWindow: false,
  },
];

export const watchLinks: Array<StaticLink> = [
  {
    display: 'Swell Stories',
    href: '/series/swell-stories',
    isExternal: false,
    newWindow: false,
  },
  {
    display: 'Maps to Nowhere',
    href: '/series/maps-to-nowhere',
    isExternal: false,
    newWindow: false,
  },
  {
    display: 'Surfline TV',
    href: 'https://www.surfline.com/lp/surfline-live',
    isExternal: true,
    newWindow: true,
  },
];

export const mapLinks: Array<StaticLink> = [
  {
    display: 'Surf Spots',
    href: '/surf-reports-forecasts-cams-map',
    isExternal: false,
    newWindow: false,
  },
  {
    display: 'Wave Buoys',
    href: '/surf-reports-forecasts-cams-map/buoys',
    isExternal: false,
    newWindow: false,
  },
  {
    display: 'Wind Stations',
    href: '/surf-reports-forecasts-cams-map/wind-stations',
    isExternal: false,
    newWindow: false,
  },
  { display: 'Charts', href: '/surf-charts', isExternal: false, newWindow: false },
];

export const getAccountLinks = (showManageMembersLink: boolean = false): Array<StaticLink> => [
  {
    display: 'Account',
    href: '/account',
    isExternal: true,
    newWindow: false,
  },
  ...(showManageMembersLink
    ? [
        {
          display: 'Add People to Your Membership',
          href: '/subscriptions/manage-members',
          isExternal: true,
          newWindow: false,
          showNewNotification: false,
          eventTracking: {
            buttonText: 'Add People to Your Membership',
          },
        },
      ]
    : []),
  { display: 'Settings', href: '/settings', isExternal: false, newWindow: false },
];

export const promotionalLinks: Array<StaticLink> = [
  { display: 'Gift Cards', href: '/gift-cards', isExternal: true, newWindow: false },
];

export const productLinks: Array<StaticLink> = [
  {
    display: 'Multi-Cam',
    href: `/surf-cams`,
    newWindow: false,
  },
  { display: 'Favorites', href: '/favorites?type=live', isExternal: true, newWindow: false },
];

export const defaultAccountLinks: Array<StaticLink> = [
  ...getAccountLinks(),
  ...promotionalLinks,
  ...productLinks,
];

export const camsReportsBrowseLinks: Array<StaticLink> = [
  {
    display: 'All Surf Spots',
    href: '/surf-reports-forecasts-cams',
    isExternal: false,
    newWindow: false,
  },
  {
    display: 'Multi-Cam',
    href: '/surf-cams',
    isExternal: false,
    newWindow: false,
  },
];

export const camsReportsSeriesLinks: Array<StaticLink> = [
  {
    display: 'WaveFax',
    href: '/surf-news/wavefax/222708',
    isExternal: false,
    newWindow: false,
  },
  {
    display: 'Incoming',
    href: '/series/incoming',
    isExternal: false,
    newWindow: false,
  },
  {
    display: 'Outlooks',
    href: '/series/outlook',
    isExternal: false,
    newWindow: false,
  },
  { display: 'Hurricanes', href: '/series/hurricane', isExternal: false, newWindow: false },
  {
    display: 'Meet The Forecasters',
    href: '/lp/forecasters',
    isExternal: true,
    newWindow: true,
  },
];

export const camsReportsLinks: Array<StaticLink> = [
  ...camsReportsBrowseLinks,
  ...camsReportsSeriesLinks,
];
